import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { API_ROUTES } from 'src/app/core/http/api-routes';
import { HttpService } from 'src/app/core/http/http.service';
import { ToastrService } from 'src/app/core/services/toastr.service';
import { ClassService } from 'src/app/services/class.service';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-single-payment',
  templateUrl: './single-payment.component.html',
  styleUrls: ['./single-payment.component.css']
})
export class SinglePaymentComponent implements OnInit {

  config = { key: 'id', display: 'name' }
  formGroup: FormGroup;
  Classes: any = [];
  Students: any = [];
  Sections: any = [];
  allAccounts: any = [];
  filteredSections: any = [];
  BillTypes: any = [];
  filteredBillTypes: any = [];
  submitButtonDisable = false;
  school: any = null;
  profile: any = null;
  constructor(
    private httpApi: HttpService,
    private toastr: ToastrService,
    private classApi:ClassService,
    private fb: FormBuilder,
  ) {
    this.getStudents()
  }

  // Get Properties
  async getStudents() {
    this.Students = await this.httpApi.listAll(API_ROUTES.STUDENT_LIST_ACTIVE_RECORDS).toPromise();
    const accounts = await this.httpApi.listAll(API_ROUTES.allAccounts).toPromise();
    this.allAccounts = Array.isArray(accounts)
      ? accounts.filter((a: any) => a.status == 1)
      : [];

    this.Students = this.Students.map(st => {
      st.name = `${st.name}-${st.roll_no} (${st.mobile})`
      return st
    }).filter(i => i.fee_type != 'Free')
  }
  async ngOnInit() {
    this.createForm();
    const [classes, sections, billTypes, school] = await Promise.all([
      this.classApi.findAll(),
      this.httpApi.listAll(API_ROUTES.SECTIONS_LIST_ACTIVE_RECORDS).toPromise(),
      this.httpApi.listAll(API_ROUTES.BILLTYPES_LIST_ACTIVE_RECORDS).toPromise(),
      this.httpApi.listAll(API_ROUTES.SCHOOL_GET_RECORD).toPromise()
    ]) as [any[], any[], any[], any];
    this.Classes = classes;
    this.Sections = sections;
    this.BillTypes = billTypes.filter(b => b.type == 1 || b.type == 0);
    this.school = school;
    this.profile = {
      name: school?.name || '',
      city: [school?.address, school?.mobile].filter(Boolean).join(' - '),
      image: school?.logo ? environment.url + school.logo : ''
    };
    this.submitButtonDisable = false;

    
    //     newBalance  
  this.formGroup.get('payedAmount').valueChanges.subscribe(payedAmount => {
    const oldBalance = this.formGroup.get('oldbalance').value || 0;
    const validpayedAmount = isNaN(payedAmount) ? 0 : +payedAmount;
    const newBalance = oldBalance - validpayedAmount;

    this.formGroup.get('newBalance').setValue(
      newBalance >= 0 ? newBalance : 0,
      { emitEvent: false }
    );
  });


  // hubi inan kayaran
  this.formGroup.get('payedAmount').valueChanges.subscribe(payedAmount => {
  const oldBalance = Number(this.formGroup.get('oldbalance').value) || 0;
  const validpayedAmount = Number(payedAmount);
 
  if (validpayedAmount < 0 || validpayedAmount > oldBalance) {
    this.toastr.error("Invalid amount!");
    this.formGroup.get('payedAmount').setValue(0, { emitEvent: false });
    this.formGroup.get('newBalance').setValue(oldBalance, { emitEvent: false });
    return;
  }
 
  const newBalance = oldBalance - validpayedAmount;
  this.formGroup.get('newBalance').setValue(newBalance, { emitEvent: false });
});



  }
  createForm() {
    this.formGroup = this.fb.group({
      student: ["", Validators.required],
      name: ["", Validators.required],
      class_id: ["", Validators.required],
      section_id: ["", Validators.required],
      account_id: ["", Validators.required],
      trans_date: [this.getTodayDate(), Validators.required],
      oldbalance: [0, [Validators.required, Validators.min(0), Validators.pattern("^[0-9]+(\\.[0-9]+)?$")]],
      payedAmount: [0, [Validators.required, Validators.min(0.01), Validators.pattern("^[0-9]+(\\.[0-9]+)?$")]],
      newBalance: [0, [Validators.required, Validators.min(0), Validators.pattern("^[0-9]+(\\.[0-9]+)?$")]], 
      description: ["", [Validators.required,Validators.maxLength(255)]],
    });
  }

  private getTodayDate(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  async onselect(data) {
    if (data?.id) {
      this.formGroup.patchValue({
        student: data,
        name: data.name,
        class_id: data.class_id,
        section_id: data.section_id,
        payedAmount: 0
      }, { emitEvent: false });
      this.setSections(data.class_id);
      await this.searchStudent();
    }
  }

  setSections(class_id) { 
    this.filteredSections = []
    this.filteredBillTypes = []
    this.Sections.map(val => {
      if (val.class_id == class_id) {
        // console.log(val);
        this.filteredSections.push(val);
      }
    })
    this.BillTypes.map(val1 => {
      console.log(val1);
      val1.classes.map(val2 => {
        if (val2.class_id == class_id) {
          this.filteredBillTypes.push(val1);
        }
      })
    })
  }
  setAmount(id) {
    this.filteredBillTypes.map(val => {
      // console.log('bill ', val);
      if (val.id == id) {
        this.formGroup.get("amount").setValue(val.amount);
        this.formGroup.get("balance").setValue(val.amount);
      }
    })
  }

   
  async submitData() {
    try {
      const receiptData = this.buildReceiptData();
      const result = await this.httpApi.post(API_ROUTES.payedAmount, this.formGroup.value).toPromise();

      if (result?.data?.id) {
        receiptData.receiptNo = result.data.id;
        receiptData.transDate = result.data.trans_date || receiptData.transDate;
      }

      this.toastr.success('Payment completed successfully.');
      this.printReceipt(receiptData);
      this.filteredBillTypes = [];
      this.formGroup.reset();
      this.formGroup.patchValue({
        trans_date: this.getTodayDate(),
        oldbalance: 0,
        payedAmount: 0,
        newBalance: 0
      });
    } catch (error) {
      this.toastr.error(error.message);
    }
  }

  private buildReceiptData() {
    const form = this.formGroup.getRawValue();
    const student = form.student || {};
    const className = this.Classes.find(c => c.id == form.class_id)?.name || '';
    const sectionName = this.Sections.find(s => s.id == form.section_id)?.name || '';
    const accountName = this.allAccounts.find(a => a.id == form.account_id)?.account_name || '';

    return {
      receiptNo: null,
      printedAt: new Date(),
      transDate: form.trans_date,
      studentName: form.name || student.name || '',
      rollNo: student.roll_no || '',
      mobile: student.mobile || '',
      className,
      sectionName,
      accountName,
      description: form.description || '',
      previousBalance: Number(form.oldbalance) || 0,
      amountPaid: Number(form.payedAmount) || 0,
      newBalance: Number(form.newBalance) || 0
    };
  }

  private formatMoney(value: number): string {
    return Number(value || 0).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  private formatDate(value: string | Date): string {
    if (!value) return '';
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    return date.toLocaleDateString('en-GB');
  }

  printReceipt(receipt: any) {
    const schoolName = this.profile?.name || this.school?.name || '';
    const schoolAddress = this.profile?.city || '';
    const logo = this.profile?.image || '';
    const printedAt = this.formatDate(receipt.printedAt);
    const transDate = this.formatDate(receipt.transDate);

    const html = `
      <div class="receipt">
        <div class="header">
          <div class="header-left">
            <h1>${schoolName}</h1>
            <p>${schoolAddress}</p>
          </div>
          ${logo ? `<div class="header-logo"><img src="${logo}" alt="School logo"></div>` : ''}
          <div class="header-right">
            <h2>Payment Receipt</h2>
            <p>Receipt No: <strong>${receipt.receiptNo || '—'}</strong></p>
            <p>Print Date: ${printedAt}</p>
          </div>
        </div>

        <div class="section-title">Student Information</div>
        <table class="info-table">
          <tr><td>Student Name</td><td>${receipt.studentName}</td></tr>
          <tr><td>Roll No</td><td>${receipt.rollNo || '—'}</td></tr>
          <tr><td>Mobile</td><td>${receipt.mobile || '—'}</td></tr>
          <tr><td>Class</td><td>${receipt.className || '—'}</td></tr>
          <tr><td>Section</td><td>${receipt.sectionName || '—'}</td></tr>
        </table>

        <div class="section-title">Payment Information</div>
        <table class="info-table">
          <tr><td>Transaction Date</td><td>${transDate}</td></tr>
          <tr><td>Payment Account</td><td>${receipt.accountName || '—'}</td></tr>
          <tr><td>Previous Balance</td><td>$${this.formatMoney(receipt.previousBalance)}</td></tr>
          <tr class="highlight"><td>Amount Paid</td><td>$${this.formatMoney(receipt.amountPaid)}</td></tr>
          <tr><td>New Balance</td><td>$${this.formatMoney(receipt.newBalance)}</td></tr>
          <tr><td>Description</td><td>${receipt.description || '—'}</td></tr>
        </table>

        <div class="footer">
          <p>Thank you for your payment.</p>
          <p class="signature">Authorized Signature: _________________________</p>
          <p class="developer-footer">Developed by <strong>Easytech Solutions</strong></p>
        </div>
      </div>
    `;

    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow!.document;
    doc.open();
    doc.write(`<!DOCTYPE html>
<html>
<head>
  <title>Payment Receipt</title>
  <style>
    * { box-sizing: border-box; }
    body {
      font-family: Arial, sans-serif;
      color: #111;
      margin: 24px;
    }
    .receipt {
      max-width: 760px;
      margin: 0 auto;
      border: 1px solid #ccc;
      padding: 24px;
    }
    .header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 16px;
      border-bottom: 2px solid #222;
      padding-bottom: 16px;
      margin-bottom: 20px;
    }
    .header h1 {
      margin: 0 0 8px;
      font-size: 22px;
    }
    .header h2 {
      margin: 0 0 8px;
      font-size: 18px;
      text-align: right;
    }
    .header p {
      margin: 0 0 4px;
      font-size: 13px;
    }
    .header-right p {
      text-align: right;
    }
    .header-logo img {
      width: 90px;
      height: 90px;
      object-fit: contain;
    }
    .section-title {
      font-size: 15px;
      font-weight: bold;
      margin: 18px 0 10px;
      padding-bottom: 4px;
      border-bottom: 1px solid #ddd;
    }
    .info-table {
      width: 100%;
      border-collapse: collapse;
      margin-bottom: 8px;
    }
    .info-table td {
      padding: 8px 10px;
      border: 1px solid #ddd;
      font-size: 14px;
    }
    .info-table td:first-child {
      width: 38%;
      font-weight: bold;
      background: #f7f7f7;
    }
    .info-table tr.highlight td {
      background: #eef8ee;
      font-weight: bold;
    }
    .footer {
      margin-top: 28px;
      text-align: center;
      font-size: 13px;
    }
    .signature {
      margin-top: 36px;
      text-align: left;
    }
    .developer-footer {
      margin-top: 24px;
      padding-top: 12px;
      border-top: 1px solid #ddd;
      font-size: 11px;
      color: #666;
    }
    .developer-footer strong {
      color: #333;
    }
    @media print {
      body { margin: 0; }
      .receipt { border: none; max-width: 100%; }
    }
  </style>
</head>
<body>${html}</body>
</html>`);
    doc.close();

    setTimeout(() => {
      const win = iframe.contentWindow as Window;
      win.focus();
      win.print();
      setTimeout(() => {
        if (iframe.parentNode) {
          document.body.removeChild(iframe);
        }
      }, 1000);
    }, 350);
  }

async searchStudent() {
  try {
    let result = await this.httpApi.post(API_ROUTES.searchsingleBill, this.formGroup.value).toPromise();
    console.log(result);

    //     exists
    if (result && result.balance !== undefined) {
      this.formGroup.patchValue({
        oldbalance: result.balance,
        newBalance: result.balance
      });
    } else {
      this.toastr.error("No balance found for this student!");
    }

  } catch (error) {
    this.toastr.error(error.message);
  }
}
}
